import React from 'react';
import { useDispatch } from 'react-redux';
import { WATERMARK_TYPE, serviceSettingsActions } from '../../../reducers/serviceSettings';
import ToggleSwitch from '../ui/ToggleSwitch';
import SliderWithNumberInput from '../ui/SliderWithNumberInput';
import ColorAndPositionRow from '../ui/ColorAndPositionRow';

interface AnnotationSettingsSectionProps {
  serviceSettings: any;
  onSettingsChanged: () => void;
}

const AnnotationSettingsSection: React.FC<AnnotationSettingsSectionProps> = ({
  serviceSettings,
  onSettingsChanged,
}) => {
  const dispatch = useDispatch();
  const isVisible = serviceSettings.annotation_is_visible;

  const showPositionWarning =
    isVisible &&
    serviceSettings.watermark_type !== WATERMARK_TYPE.NONE &&
    (serviceSettings.annotation_position || 'bottom-center') === (serviceSettings.watermark_position || 'center');

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <div style={{ fontWeight: 500, fontSize: 15, color: '#444' }}>注釈</div>
        <ToggleSwitch
          checked={isVisible}
          onToggle={() => {
            const newVisible = !isVisible;
            dispatch(serviceSettingsActions.setAnnotationIsVisible(newVisible));
            if (newVisible && !serviceSettings.annotation_text) {
              dispatch(serviceSettingsActions.setAnnotationText('この画像はCGになります。実際は家具は含まれておりません。'));
            }
            onSettingsChanged();
          }}
        />
      </div>

      {isVisible && (
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 16 }}>
          {/* テキスト入力 */}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#444', fontSize: 14, fontWeight: 500 }}>
              テキスト
            </label>
            <input
              type="text"
              value={serviceSettings.annotation_text || ''}
              onChange={e => {
                dispatch(serviceSettingsActions.setAnnotationText(e.target.value.slice(0, 50)));
                onSettingsChanged();
              }}
              style={{
                fontSize: 14,
                padding: '8px 12px',
                borderRadius: 6,
                border: '1px solid #bbb',
                width: '100%',
                lineHeight: '20px',
              }}
              maxLength={50}
              placeholder="注釈テキストを入力（最大50文字）"
            />
          </div>

          {/* 文字色・配置 */}
          <ColorAndPositionRow
            colorValue={serviceSettings.annotation_color || '#ffffff'}
            onColorChange={(color) => {
              dispatch(serviceSettingsActions.setAnnotationColor(color));
              onSettingsChanged();
            }}
            positionValue={serviceSettings.annotation_position || 'bottom-center'}
            onPositionChange={(position) => {
              dispatch(serviceSettingsActions.setAnnotationPosition(position));
              onSettingsChanged();
            }}
          />

          {/* 透明度・サイズ */}
          <div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
            <SliderWithNumberInput
              label="透明度："
              value={serviceSettings.annotation_transparency ?? 0}
              onChange={(value) => {
                dispatch(serviceSettingsActions.setAnnotationTransparency(value));
                onSettingsChanged();
              }}
            />
            <SliderWithNumberInput
              label="サイズ："
              value={serviceSettings.annotation_scale ?? 100}
              onChange={(value) => {
                dispatch(serviceSettingsActions.setAnnotationScale(value));
                onSettingsChanged();
              }}
            />
          </div>

          {/* 配置位置の重複警告 */}
          {showPositionWarning && (
            <div style={{
              background: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: 4,
              padding: '8px 12px',
              fontSize: 13,
              color: '#856404',
              marginBottom: 12,
            }}>
              注釈とウォーターマークの配置位置が同じです。表示が重なる可能性があります。
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AnnotationSettingsSection;
